module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsTalk__panel__header__a--back-685c5c0b5b5be56d3ecf278e4a44076d.svg";